module.exports = __webpack_public_path__ + "img/1931-Scottsboro Boys.a46ebc1d.jpg";